export default __webpack_public_path__ + "static/media/client.0989a955.jpg";